import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({name: 'dateTimeOffSetPipe'})
export class DateTimeOffSetPipe implements PipeTransform {
  transform(date: Date): Date {
    const dateToBeShown = new Date(date);
    const dkOffset = moment.tz(moment.utc(), 'europe/copenhagen').utcOffset();

    if (!dateToBeShown) {
      return null;
    }
    const timeOffSetInMs: number = (dateToBeShown.getTimezoneOffset() + dkOffset) * 60000;
    dateToBeShown.setTime(dateToBeShown.getTime() - timeOffSetInMs);
    return dateToBeShown;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/DateTimeOffsetPipe/DateTimeOffsetPipe.ts